<template>
<div class="section nopad">
    <div class="_1200 mobile-center w-clearfix">
        <h2 class="sec-heading epi">יצירת קשר</h2>
        <p class="text">אנו כאן לכל בקשה נוספת שלך. תראו את עצמכם חופשיים להביע את רצונכם במלל חופשי למנהלי האתר, אנו מצידנו נעשה את כל המאמצים לענות בהקדם האפשרי. תודה רבה</p>
        <div class="w-form">
            <form id="email-form-2" name="email-form-2" data-name="Email Form 2" class="contact-form">
                <input type="text" class="text-field for-form w-input" v-model="form.firstName" maxlength="256" name="name" data-name="Name" placeholder="שם פרטי" id="name">
                <input type="text" class="text-field for-form w-node-a73e8b17758e-03b3eb76 w-input" v-model="form.lastName" maxlength="256" name="Last" data-name="Last" placeholder="משפחה" id="Last" required="">
                <input type="text" class="text-field for-form w-node-a73e8b17758f-03b3eb76 w-input" v-model="form.phone" maxlength="256" name="Phone" data-name="Phone" placeholder="סלולר" id="Phone">
                <input type="text" class="text-field for-form w-node-a73e8b177590-03b3eb76 w-input" v-model="form.email" maxlength="256" name="email" data-name="Email" placeholder="דוא״ל" id="email" required="">
                <textarea id="message" name="message" placeholder="הודעה" maxlength="5000" data-name="Message" v-model="form.message" class="text-field for-form w-node-a73e8b177591-03b3eb76 w-input"></textarea>
                <input type="submit" @click="submit($event)" value="שליחה" data-wait="נא להמתין" id="w-node-a73e8b177592-03b3eb76" class="button w-button">
                <div class="contact-side-box">
                    <a href="tel:0556633201" class="con-link-box w-inline-block w-clearfix"><img src="https://uploads-ssl.webflow.com/5b2113283b783bcbb25cfd57/5b347251e85181552450f863_mobile.svg" width="24" alt="" class="image-21">
                        <div class="txt-con">055-66-33-201</div>
                    </a>
                    <a href="#" class="con-link-box w-inline-block w-clearfix"><img src="https://uploads-ssl.webflow.com/5b2113283b783bcbb25cfd57/5b34725167f59701d0210135_loca.svg" width="24" alt="" class="image-22">
                        <div class="txt-con">
                          ת.ד. 3343 רמת-גן 5213601
                            </div>
                    </a>
                    <a href="https://www.facebook.com/mikra.org.il/" target="_blank"  class="con-link-box w-inline-block w-clearfix">
                        <img src="https://uploads-ssl.webflow.com/5b2113283b783bcbb25cfd57/5b347251ff575573676b172b_face.svg" width="24" alt="" class="image-22">
                        <div class="txt-con">@mikra.org.il‎‏</div>
                    </a>
                    <a href="mailto:info@Hamikra.org" class="con-link-box w-inline-block w-clearfix"><img src="https://uploads-ssl.webflow.com/5b2113283b783bcbb25cfd57/5b34725167f597a8e4210134_mail.svg" width="24" alt="" class="image-22">
                        <div class="txt-con">info@Hamikra.org</div>
                    </a>
                </div>
            </form>
            <div class="success-message w-form-done">
                <div>תודה על שליחת ההודעה</div>
            </div>
            <div class="w-form-fail">
                <div class="text-block-5">חלה טעות נא לנסות שוב</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            form:{
                firstName:'',
                lastName:'',
                phone:'',
                email:'',
                message:''
            }
        }
    },
    methods:{
        submit(e){
            e.preventDefault();
            db.collection('/collections/rtoPcv0n4cKAp8f0Yz4V/items').add(this.form).then(()=>{
                $('#email-form-2').hide()
                $('.success-message').show()
            })
        }
    }

}
</script>

<style>

</style>
